import React from 'react';

/* Common */
import { Button, Icon } from '~/components/common';

/* Icons */
import AlertIcon from '~/../symbols/alert.svg';

export default function CardVacancyAlert({ vacancy }) {
    const link = vacancy?.links?.[0];

    return (
        <div className="card card--vacancy-alert card--link text--sm text-decoration-none">
            <div className="card__header" />
            <div className="card-body d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex flex-row gap-3 flex-md-column mb-3">
                    <Icon
                        size={32}
                        url={AlertIcon}
                        className="flex-shrink-0 mt-1 align-self-md-center"
                    />
                    <p className="title text--20 text--md-25 text-muted--100 text-base line-height-1 font-weight-bold text-left text-md-center mb-2">{vacancy.title}</p>
                </div>

                {link && (
                    <Button
                        className="d-flex w-100 justify-content-center"
                        theme="white"
                        title={link.title}
                        href={link.href}
                        showIcon={false}
                    />
                )}
            </div>
        </div>
    );
}
